import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { InvoiceTableComponent } from '../../Partials/invoice-table/invoice-table.component';
import { PaymentTableComponent } from '../../Partials/payment-table/payment-table.component';
import { RefundTableComponent } from '../../Partials/refund-table/refund-table.component';
import { CreditNoteTableComponent } from '../../Partials/credit-note-table/credit-note-table.component';
import { DunningPanelComponent } from '../../Partials/dunning-panel/dunning-panel.component';
import { BillingDocumentsFacade } from '../../../../../Facades/Billing/billing-documents.facade';
import {
  BILLING_DEFAULT_TAB,
  BILLING_TABS,
  BILLING_TAB_QUERY_PARAM,
} from '../../../../../Consts/billing-documents.const';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-billing-documents',
  standalone: true,
  imports: [
    RouterLink,
    MatIconModule,
    InvoiceTableComponent,
    PaymentTableComponent,
    RefundTableComponent,
    CreditNoteTableComponent,
    DunningPanelComponent,
    TranslateModule,
  ],
  templateUrl: './billing-documents.component.html',
  styleUrl: './billing-documents.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class BillingDocumentsComponent {
  private readonly _route = inject(ActivatedRoute);
  private readonly _router = inject(Router);

  readonly facade = inject(BillingDocumentsFacade);

  readonly tabs = BILLING_TABS;

  private readonly _params = toSignal(this._route.paramMap);
  private readonly _query = toSignal(this._route.queryParamMap);

  readonly activeTab = computed<string>(
    () => this._query()?.get(BILLING_TAB_QUERY_PARAM) || BILLING_DEFAULT_TAB,
  );

  readonly organizationLink = computed<string>(
    () => `/organizations/${this._params()?.get('id') ?? ''}`,
  );

  constructor() {
    this._registerOrganizationParam();
  }

  selectTab(tabId: string): void {
    this._router.navigate([], {
      relativeTo: this._route,
      queryParams: { [BILLING_TAB_QUERY_PARAM]: tabId },
      queryParamsHandling: 'merge',
    });
  }

  reload(): void {
    this.facade.reload();
  }

  private _registerOrganizationParam(): void {
    effect(() => {
      this.facade.load(this._params()?.get('id') ?? '');
    });
  }
}
